export default "__VITE_ASSET__CW2$RGsa__"